import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55952775"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "exchange__fields" }
const _hoisted_2 = ["value"]
const _hoisted_3 = ["value"]
const _hoisted_4 = ["value", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("select", {
      class: "exchange__select",
      value: _ctx.currency,
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:currency', ($event.target as HTMLSelectElement).value)))
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currencyList, (currency, idx) => {
        return (_openBlock(), _createElementBlock("option", {
          key: idx,
          value: currency
        }, _toDisplayString(currency), 9, _hoisted_3))
      }), 128))
    ], 40, _hoisted_2),
    _createElementVNode("input", {
      class: "exchange__input",
      type: "number",
      value: _ctx.currencyInput,
      disabled: _ctx.disabledInput,
      onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:currencyInput', parseInt(($event.target as HTMLInputElement).value))))
    }, null, 40, _hoisted_4)
  ]))
}